import {on} from "../jsbase/events";

var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.data('id');
                return { id: rowId, $el: $rowElem, number: $rowElem.data('number') };
            },
            actions: [{
                name: 'Von Eigen-Devis entfernen',
                classNames: 'dropdown-item',
                iconClass: 'bi-box-arrow-left text-danger',
                onClick: this.removePositionFromDevis,
            // }, {
            //     name: 'Neue Position hinzufügen',
            //     classNames: 'dropdown-item',
            //     iconClass: 'bi-plus',
            //     onClick: this.addPosition,
            // }, {
            //     name: 'Position ändern',
            //     classNames: 'dropdown-item',
            //     iconClass: 'bi-pencil-square',
            //     onClick: this.changePosition,
            }],
        });
        $(this.el).on('onLoaded', this.refreshContextButtons);
    },

    // events: [{
    //     name: 'click',
    //     el(component) { return component.el.querySelectorAll('.btn-context-click'); },
    //     handler(ev) {
    //         ev.preventDefault();
    //         ev.stopPropagation();
    //         var rowEl = $(ev.target).closest(this.selector);
    //         this.menu.open(rowEl, ev);
    //     }
    // }],

    methods: {
        refreshContextButtons(ev) {
            $(ev.currentTarget).find('.btn-context-click').get().forEach((el) => {
                on(el, 'click', (cev) => {
                    cev.preventDefault();
                    cev.stopPropagation();
                    var rowEl = $(cev.target).closest(this.selector);
                    this.menu.open(rowEl, cev);
                    return false;
                });
            });
        },
        removePositionFromDevis(row) {
            if (row.id) {
                devis.removePositionFromDevis(row.id);
            }
        },
    },

}
